'use strict';

angular.module('chatEngine.messageEditor', ['ui.bootstrap', 'chatEngine.services'])

.controller('MessageEditorCtrl', ['$scope', '$modalInstance', '$http', 'originalMessage', 'index', 'source',
    'sourceName', 'messageService',
    function($scope, $modalInstance, $http, originalMessage, index, source, sourceName, messageService) {
    $scope.showLoader = false;
    $scope.message = messageService.getDefaultMessageFormat();

    if (originalMessage) {
        $scope.isNewReply = false;
        $scope.message = JSON.parse(JSON.stringify(originalMessage)); // copy
    } else {
        $scope.isNewReply = true;
        originalMessage = {};
    }

    $scope.ok = function() {
        // Let's copy everything into the original message
        for(var key in $scope.message) {
            if($scope.message.hasOwnProperty(key)) {
                originalMessage[key] = $scope.message[key];
            }
        }

        // Add it to the source array if it's a new one
        if ($scope.isNewReply) {
            source.push(originalMessage);
        }

        $modalInstance.close(originalMessage);
    };

    $scope.allowDelete = function() {
        return (source !== null && index !== null && (source.length > 1 || sourceName === 'keyword'));
    };

    $scope.delete = function() {
        if ($scope.allowDelete()) {
            source.splice(index, 1);
        }
        $modalInstance.close('delete');
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}]);
